/* unplugin-vue-components disabled */import script from "./MoHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MoHeader.vue?vue&type=script&setup=true&lang=js"

import "./MoHeader.vue?vue&type=style&index=0&id=12f52272&lang=css"
import "./MoHeader.vue?vue&type=style&index=1&id=12f52272&scoped=true&lang=scss"

import exportComponent from "D:\\H5Projects\\1carbon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12f52272"]])

export default __exports__